import {
  COUNT_AGGREGATE_BY_TITLE,
  OPPORTUNITIES_AGGREGATE_BY_TYPE_ENUM,
  OPPORTUNITIES_AGGREGATE_FIELDS_ENUM,
  OPPORTUNITIES_STACK_BY_TYPE_ENUM,
} from '../../../constants';

import { titleize } from '../../../../../../../utils/helpers';
import { useGetMaOpportunitiesAggregatesStacked } from '../../../hooks/useGetMaTransactionsOpportunitiesStacked';
import { useMemo } from 'react';

const MAX_LEGEND_ITEMS = 5;

const getStackedChartData = (data, stacks, aggregateBy, stackBy) => {
  const yAxisTitle = COUNT_AGGREGATE_BY_TITLE;
  const aggregateByTitle = titleize(aggregateBy);
  const stackByTitle = titleize(stackBy);

  const chartX = [];
  const chartYs = new Map(stacks.map((stack) => [stack, []]));
  // fill in the X and and primary Y values for each stack
  data.forEach((d) => {
    // get list of X-axis values (e.g. countries, years, etc.)
    chartX.push(d.group);
    // get list of Y-axis values for each stack (i.e., buyer, seller)
    // if stack value is not present in the data, we need to default to 0 to keep the chart consistent
    stacks.forEach((stack) => chartYs.get(stack).push(d.values[stack]?.countSum || 0));
  });

  return [...chartYs].map(([stack, chartY], idx) => ({
    // same X-axis values for all stacks
    x: chartX,
    // one Y-axis value for stack
    y: chartY,
    name: stack,
    type: 'bar',
    hovertemplate: `${stackByTitle}: ${stack} <br>${aggregateByTitle}: %{x}<br>${yAxisTitle}: %{y}<extra></extra>`,
    showlegend: idx < MAX_LEGEND_ITEMS,
  }));
};

export const useGetChartData = () => {
  // we only allow stacking values for the primary Y-axis, which for now it's always counts
  const aggregateBy = OPPORTUNITIES_AGGREGATE_BY_TYPE_ENUM.COUNTRY;
  const stackBy = OPPORTUNITIES_STACK_BY_TYPE_ENUM.SELLER;
  const fields = [OPPORTUNITIES_AGGREGATE_FIELDS_ENUM.COUNT];
  const { data, stacks, loading, error } = useGetMaOpportunitiesAggregatesStacked(
    aggregateBy,
    stackBy,
    fields,
    false, // do not skip the query
  );

  const chartData = useMemo(() => {
    return !data ? [] : getStackedChartData(data, stacks, aggregateBy, stackBy);
  }, [stackBy, data, stacks, aggregateBy]);

  return { data: chartData, loading: loading, error: error };
};
